import { createApi } from "@reduxjs/toolkit/query/react";
import { btBaseQuery } from "src/Common/common";

// Define a service using a base URL and expected endpoints
export const companyApi = createApi({
	reducerPath: "companyApi",
	baseQuery: btBaseQuery,
	tagTypes: ["Company"],

	endpoints: (builder) => ({
		getCompanys: builder.query<acompany[], void>({
			query: () => `company/`,
			providesTags: ["Company"],
		}),
		getCompanyById: builder.query<acompany, string>({
			query: (id) => `company/byid/${id}`,
			providesTags: ["Company"],
		}),
		getCompanyByCode: builder.query<acompany, string>({
			query: (code) => `company/code/${code}`,
			providesTags: ["Company"],
		}),
		insertCompany: builder.mutation({
			query: (company) => ({
				url: `/company/`,
				method: "POST",
				body: company,
			}),
			invalidatesTags: ["Company"],
		}),
		updateCompany: builder.mutation({
			query: (company) => ({
				url: `/company/`,
				method: "PUT",
				body: company,
			}),
			invalidatesTags: ["Company"],
		}),
		deleteCompany: builder.mutation({
			query: (company) => ({
				url: `/company/${company.cm_id}`,
				method: "DELETE",
				body: company,
			}),
			invalidatesTags: ["Company"],
		}),
	}),
});

// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const {
	useGetCompanysQuery,
	useGetCompanyByIdQuery,
	useGetCompanyByCodeQuery,
	useInsertCompanyMutation,
	useUpdateCompanyMutation,
	useDeleteCompanyMutation,
} = companyApi;
